interface ContentBodyPorps {
  children: any
}

export const ContentBody = (props: ContentBodyPorps) => {
  const { children } = props

  return <div>{children}</div>
}
